import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import MaterialGrid from '@material-ui/core/Grid';
import PrimaryButton from 'common/components/buttons/primaryButton';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import LoadingProgress from 'common/components/progress/loading';
import { SelectLabel } from 'common/components/fields/SelectLabel';
import { create_or_update, setFormValue } from 'helpers/formComponent';
import { FORM_RULES } from 'helpers/validations';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import {
  create,
  fileRejected,
  getDetail,
  initializeForm,
  setDetail,
  setLoading,
  update,
} from './stationHierarchiesActions';

let StationHierarchiesForm = function (props) {
  const { stationHierarchies, router, location, getDetail, setDetail } = props;

  useEffect(() => {
    if (!router.params.id) {
      props.setLoading(false);
    } else {
      setFormValue(stationHierarchies, router, location, getDetail, setDetail);
    }
  }, []);

  const stationsList = props.auth.user.establishments
    .map((item) => ({
      label: item.stations[0]?.name ? item.stations[0]?.name : `Estação não encontrada`,
      value: item.stations[0]?.id || 0,
    }))
    .filter((item) =>
      router.params.id
        ? item.label !== props.formValues?.name
        : item.value !== props.auth.user.establishments[0].stations[0].id
    );

  function onSubmit(values) {
    const { create, update } = props;
    const newValues = {
      ...values,
      station_id: values.station_id || props.auth.user.establishments[0].stations[0].id,
    };
    const firstTime = false;

    create_or_update(router, newValues, create, update, firstTime);
  }

  const renderNameField = router.params.id ? (
    <Field
      component={InputLabelOutlined}
      label="Estação (filha)"
      name="name"
      validate={[FORM_RULES.required]}
      required
      disabled={true}
      margin="normal"
    />
  ) : (
    <Field
      component={SelectLabel}
      label="Estação (filha)"
      name="name"
      validate={[FORM_RULES.required]}
      required
      options={[
        {
          label: props.auth.user.establishments[0].stations[0].name,
          value: props.auth.user.establishments[0].stations[0].id,
        },
      ]}
      margin="normal"
    />
  );

  return props.stationHierarchies.loading ? (
    <Box display="flex" height="100vh" justifyContent="center" mt={10}>
      <LoadingProgress />
    </Box>
  ) : (
    <section id="stationHierarchies-form">
      <div className="card">
        <div className="card-body">
          <h2 className="h4 card-title">Formulário</h2>
          <Form role="form" onSubmit={props.handleSubmit(onSubmit)} noValidate>
            <MaterialGrid
              container
              spacing={3}
              flexDirection="row"
              justifyContent="flex-start"
              alignItems="center">
              <MaterialGrid item xs={12} md={6} lg={4}>
                {renderNameField}
              </MaterialGrid>
              <MaterialGrid item xs={12} md={6} lg={4}>
                <Field
                  component={SelectLabel}
                  label="Estação (Pai)"
                  name="parent_station_id"
                  validate={[FORM_RULES.required]}
                  options={stationsList}
                  required
                  margin="normal"
                />
              </MaterialGrid>
              <PrimaryButton
                type="submit"
                disabled={props.stationHierarchies.buttonLoading}
                progress={parseInt(props.general.submitProgress)}>
                {props.stationHierarchies.buttonLoading ? 'Salvando' : 'Salvar'}
              </PrimaryButton>
            </MaterialGrid>
          </Form>
        </div>
      </div>
    </section>
  );
};

StationHierarchiesForm.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.any,
    }),
  }),
  catestationHierarchiesgories: PropTypes.shape({
    buttonLoading: PropTypes.any,
    loading: PropTypes.any,
  }),
  create: PropTypes.any,
  general: PropTypes.shape({
    submitProgress: PropTypes.any,
  }),
  getDetail: PropTypes.any,
  handleSubmit: PropTypes.func,
  location: PropTypes.any,
  router: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.any,
    }),
  }),
  setDetail: PropTypes.any,
  setLoading: PropTypes.func,
  update: PropTypes.any,
};

StationHierarchiesForm = reduxForm({ form: 'stationHierarchiesForm' })(StationHierarchiesForm);

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    stationHierarchies: state.stationHierarchies,
    formValues: getFormValues('stationHierarchiesForm')(state),
    general: state.general,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getDetail,
      setDetail,
      initializeForm,
      create,
      update,
      setLoading,
      fileRejected,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(StationHierarchiesForm);
